import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import React from 'react'
import { useContext } from '../Context'
import { DataSuspense } from '@ztechapps/webui.util'
import { useUser } from '@ztechapps/common.hook'
import { Stack } from 'react-bootstrap'
import { RichTextDisplay } from '@ztechapps/webui.input'

export const ChatMessages = () => {
  const context = useContext()
  const { messages, status, components, showEventsToo } = context
  const { user } = useUser()

  return (
    <DataSuspense
      error={status?.errorLoading}
      loading={status?.loading}
      isEmpty={isEmpty(messages)}
      emptyComponent={<components.messageEmpty />}
    >
      <Stack gap={2}>
        {map(messages, (e) => {
          return (
            <components.messageContent
              showEventsToo={showEventsToo}
              key={e?._id}
              content={e?.content}
              from={e?.sender ?? user}
              timeStamp={e?.timeStamp}
              currentUser={user}
              attachments={e?.attachments}
              isLeft={true}
              sender={e?.sender}
              isPublic={e?.isPublic}
              externalId={e?.externalId}
            >
              <RichTextDisplay contentHtml={e.content} />
            </components.messageContent>
          )
        })}
      </Stack>
    </DataSuspense>
  )
}
